// Typelizer digest eeabe12be061cfd549c3fb785e17c1f1
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /incoming_email_items/:incoming_email_item_id/assignment */
  create: (
    params: { incomingEmailItemId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/incoming_email_items/:incoming_email_item_id/assignment', params, options),
    method: 'post',
  }),
}
